
import { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { SendDocumentDataType } from "@/formTypes/SendDocumentDataType";
import { OpenSendBackupToEmailPubSub, OpenSendBackupToEmailPubSubPayload } from "@utils/pubsubs/PubSub";
import { generateAndUploadPdf } from "@utils/htmlExport";
import SendBackupToEmailForm from "@components/forms/SendBackupToEmailForm";

type SendBackupToEmailOffCanvasProps = {
} & DefaultOffCanvasProps

const SendBackupToEmailOffCanvas = (props: SendBackupToEmailOffCanvasProps) => {
    const { btnColor = "primary", className, title } = props;
    const [defaultData, setDefaultData] = useState<SendDocumentDataType>({} as SendDocumentDataType);
    const [isOpen, setOpen] = useState(false);
    const [documentData, setDocumentData] = useState<OpenSendBackupToEmailPubSubPayload>({} as OpenSendBackupToEmailPubSubPayload);

    useEffect(() => {
        const unsubscribe = OpenSendBackupToEmailPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenSendBackupToEmailPubSubPayload) => {
        const documentData = payload;
        setOpen(documentData.openOffCanvas || false);
        setDocumentData(documentData);

        if (documentData.toEmail) {
            setDefaultData({ emails: documentData.toEmail });
        }
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const generatePdf = () => {
        const folderPath = `${documentData.documentKind}s`.toLowerCase()
        generateAndUploadPdf(`/user/${folderPath}/print/${documentData.documentId}/0/1`, `${documentData?.suscription_numero}/pdfs/${documentData.documentKind}/${documentData.documentkey}.pdf`)
    }

    const regeneratePdf = async () => {
        const folderPath = `${documentData.documentKind}s`.toLowerCase()
        await generateAndUploadPdf(`/user/${folderPath}/print/${documentData.documentId}/0/1`, `${documentData?.suscription_numero}/pdfs/${documentData.documentKind}/${documentData.documentkey}.pdf`)
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    {title}
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <p>
                            Por favor ingrese la dirección de correo electrónico a la cual será enviada el respaldo del sistema
                        </p>
                        <SendBackupToEmailForm
                            defaultData={defaultData}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default SendBackupToEmailOffCanvas;
